module.exports = __webpack_public_path__ + "static/media/leave-request.e17d434d.svg";